// Override webpack's auto publicPath when document.currentScript is unavailable
// (i.e. the script was loaded with `async` or `defer`). In that case webpack's
// built-in fallback walks the script tags from last to first and uses the src
// of whatever it finds, which is often *not* our script — leading to chunk
// requests against the wrong origin (e.g. a customer's analytics script URL).
//
// This module runs before any other code in the bundle (it's imported first in
// index.js and has no imports of its own). It targets specifically a script
// whose URL ends in /main.js, which is unambiguous in practice for our embed.
// Still a heuristic — would mis-target if a customer's page has another script
// also named main.js loaded after ours.

if (typeof document !== 'undefined' && !document.currentScript) {
  const scripts = document.querySelectorAll('script[src]');
  for (let i = scripts.length - 1; i >= 0; i -= 1) {
    const { src } = scripts[i];
    if (/\/main\.js(\?.*)?$/.test(src)) {
      // eslint-disable-next-line no-undef, camelcase
      __webpack_public_path__ = src.slice(0, src.lastIndexOf('/') + 1);
      break;
    }
  }
}
